// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__bZVpK","rotateIcon":"styles_rotateIcon__-4JI5","preview":"styles_preview__zbvgV","previewSaving":"styles_previewSaving__lG2Zu"};